/**
 * cm-pack-reward.js — the pack reward on the store (Mark, 2026-10-14): "if someone orders 3 items, they get 2 $100 gift
 * cards to use or share, or if they order 5 items they get 4 ... it would need to be present in the spa pdp price
 * ladder, in the cart and in checkout"; then, simpler: "the any 3 and 5 row should have instead, to the right of the most
 * right column a + gift icon with tooltip i next to it. when tapped the tooltip should have different text per 3 or 5";
 * the cart "just add + X gift cards worth $Y each" to its Includes line ("your additions were just crowding the ui").
 *
 * Terms: window.__cmPackReward (layout/theme.liquid, from the shop metafield cm_ad.pack_reward that the Gift cards
 * panel writes): { on, amount, ends_on, cards3, cards5 }. Shown only while on, up to the last day (shop time), and only
 * on the AU site (AUD). The cards themselves are made after the order (worker emamaco-pack-reward.ts), counted the
 * same way as piecesInCart below: no gift cards, nothing unshipped or on a subscription (Mum Club), nothing free.
 *
 * window.cmPackReward:
 *   live()                  on, in the campaign, AUD
 *   cardsFor(pieces)        3 or 4 pieces earn cards3, 5 or more cards5
 *   cell(pieces)            the price table's cell after the last column: "+", gift icon, (i); a tap opens the tooltip
 *   includesSuffix(pieces)  " + 2 gift cards worth $100 each" for the cart's Includes line, or ''
 *   piecesInCart(cart)      pieces in a /cart.js cart that earn cards
 * Any [data-pr-info] opens the tooltip beside it, worded for its data-pr-pieces. 'cm:pack-reward-ready' fires once this
 * has loaded, so a surface drawn earlier can draw again.
 *
 * NO EMOJIS anywhere in this file, per the house style.
 */
(function () {
  'use strict';
  if (window.cmPackReward) return;

  function cfg() { return window.__cmPackReward || null; }
  function shopToday() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Melbourne', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function live() {
    var c = cfg();
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return !!(c && c.on && c.ends_on && shopToday() <= c.ends_on && (!cur || cur === 'AUD') && Number(c.amount) > 0);
  }
  function cardsFor(pieces) {
    var c = cfg() || {};
    if (pieces >= 5) return Number(c.cards5) || 0;
    if (pieces >= 3) return Number(c.cards3) || 0;
    return 0;
  }
  function money() { var a = Number((cfg() || {}).amount) || 0; return '$' + (a % 1 === 0 ? String(a) : a.toFixed(2)); }
  function untilText() {
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String((cfg() || {}).ends_on || ''));
    if (!d) return '';
    try { return new Date(Number(d[1]), Number(d[2]) - 1, Number(d[3])).toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/,/g, ''); }
    catch (e) { return d[0]; }
  }
  function cardsWorth(n) { return n + ' gift card' + (n === 1 ? '' : 's') + ' worth ' + money() + ' each'; }

  var GIFT = '<svg class="cm-pr-gift" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"></path></svg>';
  var INFO = '<svg class="cm-pr-info" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>';

  /** The price table's cell for the 3 and 5 rows: one button, "+", the gift, the (i). */
  function cell(pieces) {
    var n = cardsFor(pieces);
    if (!live() || !(n > 0)) return '';
    return '<button type="button" class="cm-pr-cell" data-pr-info data-pr-pieces="' + pieces + '" aria-label="' + cardsWorth(n) + ' with ' + pieces + ' items">'
      + '<span class="cm-pr-plus">+</span>' + GIFT + INFO + '</button>';
  }
  function includesSuffix(pieces) {
    var n = cardsFor(pieces);
    return live() && n > 0 ? ' + ' + cardsWorth(n) : '';
  }
  function piecesInCart(cart) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.gift_card || it.requires_shipping === false || it.selling_plan_allocation) return;
      if (/mum club/i.test(String(it.product_title || it.title || ''))) return;
      if (!(Number(it.final_line_price) > 0)) return;
      n += Number(it.quantity) || 0;
    });
    return n;
  }

  // ── the tooltip: Mark's four lines, for the row that was tapped ──
  function infoHtml(pieces) {
    var n = cardsFor(pieces);
    return '<div class="cm-pr-b-top">' + GIFT
      + '<p class="cm-pr-b-h">Order ' + pieces + ' items and we will send you ' + cardsWorth(n) + '</p></div>'
      + '<p class="cm-pr-b-p">that you can use or gift on.</p>'
      + '<p class="cm-pr-b-f">Valid until ' + untilText() + '</p>'
      + '<p class="cm-pr-b-f">1 gift card usable per order</p>';
  }
  var bubble = null, anchor = null, anchorTop = 0;
  function closeInfo() { if (bubble) { bubble.remove(); bubble = null; anchor = null; } }
  function openInfo(btn) {
    if (anchor === btn) { closeInfo(); return; }
    closeInfo();
    var pieces = Number(btn.getAttribute('data-pr-pieces')) || 3;
    if (!(cardsFor(pieces) > 0)) return;
    anchor = btn;
    bubble = document.createElement('div');
    bubble.className = 'cm-pr-bubble';
    bubble.setAttribute('role', 'dialog');
    bubble.setAttribute('aria-label', 'Gift cards with ' + pieces + ' items');
    bubble.innerHTML = infoHtml(pieces);
    document.body.appendChild(bubble);
    var r = btn.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    anchorTop = r.top;
    var w = Math.min(290, vw - 24);
    bubble.style.width = w + 'px';
    // Its right edge near the (i), kept on screen.
    var left = Math.max(12, Math.min(vw - w - 12, r.right - w + 8));
    var h = bubble.offsetHeight;
    var below = r.bottom + 8 + h <= vh - 8;
    bubble.style.left = left + 'px';
    bubble.style.top = (below ? r.bottom + 8 : Math.max(8, r.top - 8 - h)) + 'px';
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pr-info]') : null;
    if (b) { e.preventDefault(); e.stopPropagation(); openInfo(b); return; }
    if (bubble && !(e.target && e.target.closest && e.target.closest('.cm-pr-bubble'))) closeInfo();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeInfo(); });
  // Closes when she scrolls the (i) away (the page, or the cart), not when a gallery or carousel elsewhere scrolls itself.
  window.addEventListener('scroll', function () {
    if (bubble && anchor && Math.abs(anchor.getBoundingClientRect().top - anchorTop) > 24) closeInfo();
  }, { passive: true, capture: true });
  window.addEventListener('resize', closeInfo);

  var css = ''
    + '.cm-pr-cell{display:inline-flex;align-items:center;gap:2px;margin:-6px -2px -6px 0;padding:6px 2px;border:0;background:transparent;color:#15803d;cursor:pointer;line-height:1;font:inherit;letter-spacing:normal;text-transform:none;-webkit-tap-highlight-color:transparent;}'
    + '.cm-pr-plus{font-size:14px;font-weight:800;line-height:1;}'
    + '.cm-pr-cell .cm-pr-gift{width:15px;height:15px;flex:0 0 auto;}'
    + '.cm-pr-cell .cm-pr-info{width:13px;height:13px;flex:0 0 auto;color:#6b7280;margin-left:1px;}'
    + '.cm-pr-bubble{position:fixed;z-index:100020;background:#1f2937;color:#fff;border-radius:10px;padding:14px 16px;box-shadow:0 12px 32px rgba(0,0,0,.28);font-family:system-ui,-apple-system,sans-serif;letter-spacing:normal;text-transform:none;text-align:left;}'
    + '.cm-pr-bubble p{margin:0;}'
    + '.cm-pr-b-top{display:flex;align-items:flex-start;gap:10px;}'
    + '.cm-pr-b-top .cm-pr-gift{width:20px;height:20px;flex:0 0 auto;color:#86efac;margin-top:1px;}'
    + '.cm-pr-b-h{font-size:14.5px;font-weight:700;line-height:1.4;color:#fff;}'
    + '.cm-pr-b-p{font-size:14px;line-height:1.4;color:#e5e7eb;margin:2px 0 10px 30px !important;}'
    + '.cm-pr-b-f{font-size:12.5px;line-height:1.5;color:#9ca3af;margin-left:30px !important;}'
    + '.cm-pr-b-f + .cm-pr-b-f{margin-top:0 !important;}'
    + '.cm-pr-b-p + .cm-pr-b-f{padding-top:9px;border-top:1px solid rgba(255,255,255,.14);}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  window.cmPackReward = { live: live, cardsFor: cardsFor, cell: cell, includesSuffix: includesSuffix, piecesInCart: piecesInCart };
  try { window.dispatchEvent(new CustomEvent('cm:pack-reward-ready')); } catch (e) {}
})();
